<template functional>
  <div
    class="loader-container"
  >
    <v-progress-circular
      indeterminate
      class="tabloader"
      color="blue"
      width="2"
      size="38"
    />
  </div>
</template>

<script>
export default {
  name: 'LoaderContainer'
}
</script>

<style lang="scss" scoped>
.loader-container {
  min-height: 465px;
}
.tabloader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
